import React from 'react';
import AdminConfigProviderConfig from './AdminConfigProviderConfig';
import CoreProviderConfig from './CoreProviderConfig';
import DocMgmtProviderConfig from './DocMgmtProviderConfig';
import { LDProvider } from 'launchdarkly-react-client-sdk';

type ServiceProviderProps = {
    children: React.ReactNode;
    token: string;
};

const ldConfig = {
    clientSideID: LAUNCHDARKLY_SETTINGS.clientSideID,
    environment: APP_ENVIRONMENT,
    options: {
        plugins: [],
    },
};

const ServiceProviders: React.FC<ServiceProviderProps> = ({ children, token }: ServiceProviderProps) => (
    <CoreProviderConfig token={token}>
        <LDProvider {...ldConfig}>
            <AdminConfigProviderConfig token={token}>
                <DocMgmtProviderConfig token={token}>{children}</DocMgmtProviderConfig>
            </AdminConfigProviderConfig>
        </LDProvider>
    </CoreProviderConfig>
);

export default ServiceProviders;
